export const loadingGifUrl: string = `https://i.gifer.com/VAyR.gif`
